<div *ngIf="type == 'generic'">
  <div class="loading-header">
    <div>
      <img id="img_logo" src="./assets/img/new-brand.png" alt="Itaú logo" />
    </div>
  </div>
  <div class="loading-container">
    <div>
      <div>
        <mat-progress-spinner [mode]="mode"></mat-progress-spinner>
        <div>
          <span> {{ 'PLEASE' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- IMPLEMENTATION NEW LOADING-->
<div *ngIf="type !== 'generic'">
  <ng-template #progressSpinnerRef>
    <div class="loading-container">
      <div class="displayed">
        <div>
          <mat-progress-spinner [value]="value" [mode]="mode"></mat-progress-spinner>
          <div>
            <span> {{ 'PLEASE' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>